import { render, staticRenderFns } from "./PlayTheRack.vue?vue&type=template&id=a2ec5b48"
import script from "./PlayTheRack.vue?vue&type=script&lang=ts"
export * from "./PlayTheRack.vue?vue&type=script&lang=ts"
import style0 from "./PlayTheRack.vue?vue&type=style&index=0&id=a2ec5b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports